import { createSlice } from '@reduxjs/toolkit';

const RegistrationSlice = createSlice({
    name: 'regFormOutput',
    initialState: {
        createdCard: false,
        registrationCard: {
            activeDoc: '',
            day: '',
            year: '',
            mounth: '',
            biopsiya: '',
            cardNumber: '', 
            clinicalConclusion: '', 
            clinicalInfo: '', 
            department: '', 
            gender: '', 
            hospital: '', 
            markedMaterial: '', 
            operationDateName: '',
            operationName: '',
            patientName: '', 
            patientNumber: '', 
            quantityMaterial: '',
            research: '',
            phoneNumber: '',
            status: '',
            id: '',
            qr: ''
        },
    },
    reducers: {
        cardCreation: (state,action) => {
            state.createdCard = true
            state.registrationCard = action.payload.credential
        },
        cardClean: (state) => {
            state.createdCard = false
            state.registrationCard = {
                id: '',
                activeDoc: '',
                day: '',
                year: '',
                mounth: '',
                biopsiya: '',
                cardNumber: '', 
                clinicalConclusion: '', 
                clinicalInfo: '', 
                department: '', 
                gender: '', 
                hospital: '', 
                markedMaterial: '', 
                operationDateName: '',
                operationName: '',
                patientName: '', 
                patientNumber: '', 
                quantityMaterial: '',
                research: '',
                phoneNmber: '',
                status: '',
            }
        }
    }
})

export const { cardCreation, cardClean } = RegistrationSlice.actions;
export default RegistrationSlice